module.exports = __webpack_public_path__ + "static/img/img_1.eaca21e2.jpg";